// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropzone[data-v-7a0b9382],\n.dropzone .dz-message[data-v-7a0b9382] {\n    margin: 0;\n    padding: 0;\n}\n.dropzone[data-v-7a0b9382] {\n    border: 3px dashed #31369d;\n    height: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
